module.exports = __webpack_public_path__ + "img/introduction-logo.ec4470fb.png";